import ArchiveIcon from "@mui/icons-material/Archive";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import React, { useMemo } from "react";

import { getActionBackgroundColor } from "../utils/archiverUtils";
import { darkTheme } from "../utils/Themes";

export default function CandidateActions({ candidate, actionTypes, onActionIconClick }) {
  const hasAlreadyExists = useMemo(() => {
    const additional = candidate.additionalEpisodes ?? [];
    return candidate.episodeAlreadyExists || additional.some((a) => a.episodeAlreadyExists);
  }, [candidate]);

  const archiveButtonId = hasAlreadyExists ? "Override" : "Archive";

  return (
    <Grid container spacing={0} justifyContent="flex-end">
      <Grid>
        <IconButton
          id="Delete"
          name={candidate.path}
          onClick={onActionIconClick}
          aria-label="delete"
          style={{
            backgroundColor: getActionBackgroundColor(candidate, "Delete", actionTypes),
            marginLeft: 10,
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Grid>

      <Grid>
        <IconButton
          id={archiveButtonId}
          name={candidate.path}
          onClick={onActionIconClick}
          aria-label={archiveButtonId.toLowerCase()}
          style={{
            backgroundColor: getActionBackgroundColor(candidate, archiveButtonId, actionTypes),
            color: hasAlreadyExists ? darkTheme.palette.secondary.main : undefined,
            marginLeft: 10,
          }}
        >
          <ArchiveIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}
